<div class="title-bar">
    <h2 class="global-title">
    Leads
    </h2>
</div>
<div>
    <div class="top-bar">
        <div class="top-bar-item">
            <p-selectButton [options]="leadsFilterService.displayOptions" [(ngModel)]="leadsFilterService.selectedDisplayOption" (onChange)="doMultiFilterSearch(0)">
            </p-selectButton>
        </div>
        <div class="top-bar-item">
            <p-button label="Add new" routerLink="/management/create-contact-request"></p-button>
        </div>
        <div class="top-bar-item">
            <p-button icon="pi pi-filter" label="Reset filter" (onClick)="resetSearchForm()"></p-button>
        </div>
    </div>
</div>
<ng-container *ngIf="leads && searchForm">
    <p-table [value]="leads" [lazy]="true" (onLazyLoad)="lazyLoad($event)" [paginator]="true" [tableStyle]="{width: '1680px'}" styleClass="p-datatable-striped"
    [loading]="loading" [rows]="recordsByPage" [totalRecords]="totalRecords" [rowsPerPageOptions]="pageRecordsOptions" [showCurrentPageReport]="true" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">
        <ng-template pTemplate="header">
            <tr>
                <th [style]="{width: '50px'}">
                    ID
                </th>
                <th [style]="{width: '75px'}">
                    Lead Type
                </th>
                <th [style]="{width: '150px'}">
                    Name
                </th>
                <th [style]="{width: '100px'}">
                    School
                </th>
                <th>
                    Program
                </th>
                <th [style]="{width: '140px'}">
                    Email
                </th>
                <th [style]="{width: '70px'}">
                    Language
                </th>
                <th [style]="{width: '90px'}">
                    Status
                </th>
                <th [style]="{width: '80px'}">
                    Received
                </th>
            </tr>
            <tr [formGroup]="searchForm">
                <th>
                    <input pInputText [style]="{'width': '70px'}" formControlName="leadId" (input)="updateNumberFilter($event)">
                </th>
                <th class="dropdown-container">
                    <p-dropdown [showClear]="true" placeholder="Select" (onChange)="doMultiFilterSearch(0)" formControlName="leadType"
                     [options]="leadTypes" optionLabel="name" [style]="{'width': '110px', 'min-width': '110px'}" appendTo="body"></p-dropdown>
                </th>
                <th>
                    <input pInputText [style]="{'width': '240px'}" formControlName="name" (input)="updateStringFilter($event)">
                </th>
                <th>
                    <p-dropdown appendTo="body" [showClear]="true" placeholder="Select" [filter]="true" filterBy="name" (onChange)="doMultiFilterSearch(0)" [options]="schools" formControlName="school" optionLabel="name" [style]="{'min-width': '160px', 'width': '160px'}"></p-dropdown>
                </th>
                <th>
                    <input pInputText [style]="{'width': '100%'}" formControlName="interestedIn" (input)="updateStringFilter($event)">
                </th>
                <th>
                    <input pInputText [style]="{'width': '220px'}" formControlName="email" (input)="updateStringFilter($event)">
                </th>
                <th>
                    <p-dropdown appendTo="body" [showClear]="true" placeholder="Select" (onChange)="doMultiFilterSearch(0)" [options]="languages" formControlName="language" optionLabel="name" [style]="{'min-width': '90px', 'width': '90px'}"></p-dropdown>
                </th>
                <th></th>
                <th></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-request let-index="rowIndex">
            <tr [pSelectableRow]="request" [ngClass]="{'table-row-even': index%2==0}">
                <td>
                    {{request.id}}
                </td>
                <td>
                    {{request.leadType.name | titlecase}}
                </td>
                <td class="name-box">
                    <a routerLink="/management/wp-contact-request-edit-navigation/{{request.id}}">
                        {{request.firstName}} {{request.lastName}}
                    </a>
                </td>
                <td>
                    <p *ngIf="request.school">
                        {{request.school.name}}
                    </p>
                </td>
                <td>
                    {{request.interestedIn}}
                </td>
                <td class="email-box">
                    {{request.email}}
                </td>
                <td>
                    <p *ngIf="request.language">
                        {{request.language.name}}
                    </p>
                </td>
                <td>
                    <div *ngIf="request.leadStatus" [ngClass]="{'new': request.leadStatus.id == 1, 'processing': request.leadStatus.id == 2, 'done': request.leadStatus.id == 3}">
                        {{request.leadStatus.name | titlecase}}
                    </div>
                </td>
                <td>
                    {{request.created | date:"dd/MM/yyyy HH:mm"}}
                </td>
            </tr>
        </ng-template>
    </p-table>
</ng-container>
